/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetYahooCampaignsRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {GetYahooCampaignsResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const getYahooCampaigns = (request:GetYahooCampaignsRequest, options?: CashRequestOptions) => post<GetYahooCampaignsRequest, GetYahooCampaignsResponse>("/2.0/cash/get-yahoo-campaigns", request, {...options, rejectOnError: true })